module.exports = __webpack_public_path__ + "media/Safe_Mobile.59586ced.mp4";